import React from 'react';
import { useTranslation } from '../App';

const Brand = () => {
  const t = useTranslation();
  return (
    <section className="brand">
      <h1>{t.brand.line1}</h1>
      <h1>{t.brand.line2}</h1>
      <h1>{t.brand.line3}</h1>
    </section>
  );
};

export default Brand;